import { Box, Button, Checkbox, createTheme, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputBase, ThemeProvider, Typography } from '@material-ui/core';
import * as React from 'react';
import { useEffect, useState } from 'react';
import useStyles from 'src/app/maintenance/assets/styles';
import { DateTimeSelectorComponent } from 'src/app/maintenance/test-automation/components/DateTimeSelector';
import { DropDown } from 'src/app/maintenance/test-automation/components/DropDown';
import { ParameterDropDown } from 'src/app/maintenance/test-automation/step2/ParameterDropDown';
import DeviceConfig from 'src/app/maintenance/test-automation/step3/DeviceConfig';
import { CollapseTestCaseIcon, DecreaseIcon, ExpandTestCaseIcon, IncreaseIcon } from 'src/components/Icons';

export const TestingStepComponent = ({ groupId, templates, parameterOptions, selectedParameters, handleParameterChange,  batchNumbers, handleSelectBatchNumber, selectedBatch, handlePopupClose, step, errors, handleNext, handleBack, testCaseTypes, selectedTestCaseType, handleSelectTestingMethod, responseTime, handleResponseTime, handleIncrease, handleDecrease, shedulePeriod, selectedPeriod, handleSchedulePeriod, selectedSubTestCases, handleCheckboxChange, handleValueChange, modifiedValues, selectedStartDate, handleStartDateChange, selectedEndtDate, handleEndDateChange, definedTestCases, initialBatch, initialStreamingMethod }) => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    const [expandedIds, setExpandedIds] = useState<string[]>([]);
    const [filteredSubTestCases, setFilteredSubTestCases] = useState([]);
    const [subTestCasesCount, setSubTestCasesCount] = useState(0);
    const [selectedSubTestCasesTitles, setSelectedSubTestCasesTitles] = useState([]);
    const [devices, setDevices] = useState([]);

    useEffect(() => {
        if (initialBatch) {
            handleSelectBatchNumber(initialBatch);
        }
    }, [initialBatch]);

    useEffect(() => {
        if (definedTestCases) {
            const allSubTestCases = definedTestCases.flatMap(testCase => 
                testCase.subTestCases.map(subCase => ({
                    ...subCase,
                    mainTestTitle: testCase.mainTestTitle
                }))
            );
            
            setFilteredSubTestCases(allSubTestCases);
            setSubTestCasesCount(allSubTestCases.length);
            setSelectedSubTestCasesTitles(allSubTestCases.map(stc => stc.subTestTitle));
            
            const allDevices = Array.from(new Set(
                definedTestCases.flatMap(tc => tc.devices || [])
            ));
            if (allDevices.length > 0) {
                setDevices(allDevices);
            }
        }
    }, [definedTestCases]);


    const handleExpandClick = (id: string) => {
        setExpandedIds(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const getParameterValue = (templateIndex: number, subIndex: number) => {
        const param = selectedParameters[`${templateIndex}-${subIndex}`];
        return param ? param.value : '';
    };

    return (
        <ThemeProvider theme={theme}>
            <Grid container style={{ padding: '25px', margin: '0px' }}>
                <Grid container alignItems="center" spacing={2}>
                    {step === 0 && (
                        <Grid item md={12} xs={12} style={{ padding: "0px" }}>
                            <Typography
                                className={classes.typo}
                                style={{ whiteSpace: 'nowrap', marginBottom: '5px' }}
                            >
                                Batch: <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <DropDown
                                options={batchNumbers.map(batch => batch)}
                                type="batchNumber"
                                emptyTag="Select"
                                setSelectOption={handleSelectBatchNumber}
                                value={selectedBatch}
                                isSingle={true}
                            />
                            {errors.batchNoError && (
                                <Grid container justifyContent="flex-end" alignItems="center">
                                    <Typography className={classes.errorText}>
                                        {errors.batchNoError}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    )}
                    {step === 0 && templates.map((template, index) => {
                        const isExpanded = expandedIds.includes(template.id);
                        const isDisabled = !selectedBatch;
                        return (
                        <Grid container key={index} className={classes.cardBackgroundContainer}>
                            <Grid item md={12} xs={12} className={classes.cardSubContainer}>
                                <Typography className={classes.mainTestTitleTypo}>
                                    {template.mainTestTitle}
                                </Typography>
                                <IconButton onClick={() => handleExpandClick(template.id)} disabled={isDisabled}>
                                    {isExpanded ? <CollapseTestCaseIcon /> : <ExpandTestCaseIcon />}
                                </IconButton>
                            </Grid>

                            {isExpanded && template.subTestCases.map((sub, subIndex) => (
                                <Grid container key={subIndex} className={classes.cardSubBackgroundContainer}>
                                    <Grid item md={12} xs={12} className={classes.subTestRow}>
                                        <Grid item md={1} xs={12} sm={1} className={classes.testCheckbox}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox 
                                                            className={classes.check}
                                                            checked={selectedSubTestCases[`${index}-${subIndex}`] || false}
                                                            onChange={(e) => handleCheckboxChange(index, subIndex, e.target.checked)}
                                                        />
                                                    }
                                                    label=""
                                                />
                                            </FormGroup>
                                        </Grid>

                                        <Grid item xs={12} md={3} style={{ marginBottom: "20px" }}>
                                            <Typography className={classes.typo} style={{ marginBottom: '5px' }}>
                                                Sub Test Case <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <InputBase
                                                className={classes.formInput}
                                                style={{ backgroundColor: '#E2E5ED' }}
                                                type="text"
                                                placeholder="Enter Sub Test Case Name"
                                                name="subTestcase"
                                                value={sub.subTestTitle || ""}
                                                disabled
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3} style={{ marginBottom: "20px" }}>
                                            <Typography
                                                className={classes.typo}
                                                style={{ whiteSpace: 'nowrap', marginBottom: '5px' }}
                                            >
                                                Parameter: <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            
                                            <ParameterDropDown
                                                options={parameterOptions}
                                                type='parameter'
                                                emptyTag='Select Parameter'
                                                setSelectOption={(selectedOption) => 
                                                    handleParameterChange(index, subIndex, selectedOption)
                                                }
                                                value={getParameterValue(index, subIndex)}
                                                isSingle={true}
                                            />
                                            {errors.parameterError && selectedSubTestCases[`${index}-${subIndex}`] && (
                                                <Grid container justifyContent="flex-end" alignItems="center">
                                                    <Typography className={classes.errorText}>
                                                        {errors.parameterError}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} md={3} style={{ marginBottom: "20px" }}>
                                            <Typography className={classes.typo} style={{ marginBottom: '5px' }}>
                                                Success Criteria: <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <InputBase
                                                className={classes.formInput}
                                                style={{ backgroundColor: '#E2E5ED' }}
                                                type="text"
                                                placeholder="Success Criteria"
                                                value={sub.successCriteria || ""}
                                                disabled
                                            />
                                        </Grid>

                                        {sub.successCriteria === "IS_BETWEEN" ? (
                                            <>
                                                <Grid item xs={12} md={3} className={classes.valueRowFlex}>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography className={classes.typo} style={{ marginBottom: '5px' }}>
                                                            Min Value: <span style={{ color: 'red' }}>*</span>
                                                        </Typography>
                                                        <InputBase
                                                            className={classes.formInput}
                                                            style={{ backgroundColor: '#FFF' }}
                                                            type="text"
                                                            name="minVal"
                                                            placeholder="Enter min value"
                                                            value={modifiedValues[`${index}-${subIndex}-minVal`] || sub.minVal || ""}
                                                            onChange={(e) => handleValueChange(index, subIndex, 'minVal', e.target.value)}
                                                        />
                                                        {errors.minValError && selectedSubTestCases[`${index}-${subIndex}`] && (
                                                            <Grid container justifyContent="flex-end" alignItems="center">
                                                                <Typography className={classes.errorText}>
                                                                    {errors.minValError}
                                                                </Typography>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography className={classes.typo} style={{ marginBottom: '5px' }}>
                                                            Max Value: <span style={{ color: 'red' }}>*</span>
                                                        </Typography>
                                                        <InputBase
                                                            className={classes.formInput}
                                                            style={{ backgroundColor: '#FFF' }}
                                                            type="text"
                                                            name="maxVal"
                                                            placeholder="Enter max value"
                                                            value={modifiedValues[`${index}-${subIndex}-maxVal`] || sub.maxVal || ""}
                                                            onChange={(e) => handleValueChange(index, subIndex, 'maxVal', e.target.value)}
                                                        />
                                                        {errors.maxValError && selectedSubTestCases[`${index}-${subIndex}`] && (
                                                            <Grid container justifyContent="flex-end" alignItems="center">
                                                                <Typography className={classes.errorText}>
                                                                    {errors.maxValError}
                                                                </Typography>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </>
                                        ) : (
                                            <>
                                                <Grid item xs={12} md={3} style={{ marginBottom: "20px" }}>
                                                    <Typography className={classes.typo} style={{ visibility: sub.successCriteria ? 'hidden' : 'visible', marginBottom: '5px' }}>
                                                        Value: <span style={{ color: 'red' }}>*</span>
                                                    </Typography>
                                                    <InputBase
                                                        className={classes.formInput}
                                                        style={{ backgroundColor: '#FFF' }}
                                                        type="text"
                                                        placeholder={sub.successCriteria ? "Enter value here" : ""}
                                                        value={modifiedValues[`${index}-${subIndex}-minVal`] || sub.minVal || ""}
                                                        onChange={(e) => handleValueChange(index, subIndex, 'minVal', e.target.value)}
                                                    />
                                                    {errors.minValError && selectedSubTestCases[`${index}-${subIndex}`] && (
                                                        <Grid container justifyContent="flex-end" alignItems="center">
                                                            <Typography className={classes.errorText}>
                                                                {errors.minValError}
                                                            </Typography>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                        );
                    })}
                    {
                        errors.subTestCaseError && (
                            <Grid container justifyContent="flex-end" alignItems="center">
                                <Typography className={classes.errorText}>
                                    {errors.subTestCaseError}
                                </Typography>
                            </Grid>
                        )
                    }
                    {step === 1 && (
                        <>
                            <Grid
                                container
                                item xs={12} md={12}
                                alignItems="center"
                            >
                                <Grid item xs={12} md={2}>
                                    <Button className={classes.subTestCaseCountTypo}>
                                       {subTestCasesCount} Sub Test Cases Applied
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography className={classes.typo} style={{ marginBottom: '5px' }}>
                                        Testing Method
                                        <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <DropDown
                                        options={testCaseTypes}
                                        type='testingMethod'
                                        emptyTag='-Select-'
                                        setSelectOption={handleSelectTestingMethod}
                                        value={selectedTestCaseType}
                                        isSingle
                                    />
                                    {errors.testingMethodError && (
                                            <Grid container justifyContent="flex-end" alignItems="center">
                                            <Typography className={classes.errorText}>
                                                {errors.testingMethodError}
                                            </Typography>
                                            </Grid>
                                        )}
                                </Grid>
                            </Grid>

                            {selectedTestCaseType === "Production Feasibility Testing" && (
                                <Grid container style={{ marginTop: "20px", padding: '5px' }}>
                                    <Grid item xs={12} md={12} className={classes.timeContainer}>
                                        <Grid container alignItems="center" style={{ padding: "10px" }}>
                                            <Grid item xs={12} md={12} className={classes.timeRow}>
                                                {/* Start Time */}
                                                <Grid item xs={12} md={6}>
                                                    <Grid item xs={12} md={12}>
                                                        <Typography className={classes.typo}>
                                                            Start Time <span style={{ color: 'red' }}>*</span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={12} >
                                                        <DateTimeSelectorComponent selectedDate={selectedStartDate} handleDateChange={handleStartDateChange} fromTestIoT={true} />
                                                        {errors.startDateError && (
                                                        <Grid container justifyContent="flex-end" alignItems="center">
                                                        <Typography className={classes.errorText}>
                                                            {errors.startDateError}
                                                        </Typography>
                                                        </Grid>
                                                    )}
                                                    </Grid>
                                                </Grid>

                                                {/* End Time */}
                                                <Grid item xs={12} md={6}>
                                                    <Grid item xs={12} md={12}>
                                                        <Typography className={classes.typo}>
                                                            End Time <span style={{ color: 'red' }}>*</span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={12} >
                                                        <DateTimeSelectorComponent selectedDate={selectedEndtDate} handleDateChange={handleEndDateChange} fromTestIoT={true} />
                                                        {errors.startDateError && (
                                                        <Grid container justifyContent="flex-end" alignItems="center">
                                                        <Typography className={classes.errorText}>
                                                            {errors.startDateError}
                                                        </Typography>
                                                        </Grid>
                                                    )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}

                            {selectedTestCaseType === "Continuous Testing" && (
                                <Grid container style={{ marginTop: "20px", padding: "5px" }}>
                                    <Grid item xs={12} md={12} className={classes.alertConatiner}>
                                        <Grid container alignItems="center">

                                            <Grid item xs={12} md={12}>
                                                <Typography className={classes.typo} style={{ color: '#324054', fontWeight: 600 }}>
                                                    Alert Schedule
                                                </Typography>
                                            </Grid>

                                            {/* Start Time */}
                                            <Grid item xs={12} md={12}>
                                                <Typography className={classes.typo} style={{ marginBottom: '5px', marginTop: '10px' }}>
                                                    Repeat Every <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} className={classes.responseTimeContainer}>
                                                <Grid item xs={12} md={6} className={classes.columnFlex}>
                                                    <InputBase
                                                        className={classes.formInput}
                                                        placeholder="Enter Duration"
                                                        name="responseTime"
                                                        value={responseTime}
                                                        onChange={(e) => {
                                                            const inputValue = e.target.value;
                                                            handleResponseTime(inputValue === '' ? '' : parseInt(inputValue, 10))
                                                        }} 
                                                        style={{ paddingRight: '0px' }}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <Box display="flex" flexDirection="column" style={{ marginTop: '-14px' }}>
                                                                    <IconButton size="small" onClick={handleIncrease} style={{ height: '15px' }}>
                                                                        <IncreaseIcon />
                                                                    </IconButton>
                                                                    <IconButton size="small" onClick={handleDecrease} style={{ height: '15px' }}>
                                                                        <DecreaseIcon />
                                                                    </IconButton>
                                                                </Box>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                    {errors.rootCauseNotificationDurationInMinutes && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.rootCauseNotificationDurationInMinutes}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={6} className={classes.columnFlex}>
                                                    <DropDown
                                                        options={shedulePeriod}
                                                        type="shedulePeriod"
                                                        emptyTag="-Select-"
                                                        setSelectOption={handleSchedulePeriod}
                                                        value={selectedPeriod}
                                                        isSingle={true}
                                                    />
                                                    {errors.period && (
                                                    <Typography className={classes.errorText}>
                                                        {errors.period}
                                                    </Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}

                            {filteredSubTestCases.length !== 0 && (
                            <Grid container style={{ marginTop: "40px" }}>
                                <Grid item xs={12}>
                                    <DeviceConfig 
                                        filteredSubTestCases={filteredSubTestCases}
                                        selectedSubTestCasesTitles={selectedSubTestCasesTitles}
                                        devices={devices}
                                    />
                                </Grid>
                            </Grid>
                            )}
                        </>
                    )}
                    <Grid container spacing={2} style={{ marginTop: "10px" }} justifyContent="flex-end">
                        <Grid item>
                            <Button
                                variant="contained"
                                className={classes.backButton}
                                onClick={step === 0 ? handlePopupClose : handleBack}
                            >
                                {step === 0 ? 'Cancel' : 'Back'}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                className={`${classes.devicePulseSaveButton} ${classes.button}`}
                                onClick={step === 0 ? handleNext : handleNext}
                                disabled={step === 0 && !selectedBatch}
                            >
                                {step === 0 ? 'Apply For Testing' : 'Start'}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ThemeProvider>
    )
}